import React, { useState } from 'react'
import { BankCardSvg } from 'src/assets/index'
import { useTypedSelector } from '../../../redux/index'
import { CardImage } from '../BankImage/BankImage'
import {
  AddNewCardContainer,
  CardContainer,
  ExistingCardWrapper,
} from './style'
import { CardArrowSvg } from 'src/assets/index'

interface ExistingCardProps {
  setPaymentOption: (option: 'card' | 'bank', data?: any) => void
  option: { name: 'bank' | 'card'; data: any }
  setShowSwitchModal: any
  // handleClick: any
}
const checkVerification = () => {
  if (window.location.href.indexOf('contest') > -1) {
    return false
  } else {
    return true
  }
}
const ExistingCard = ({
  setPaymentOption,
  option,
  setShowSwitchModal,
}: // handleClick,
ExistingCardProps) => {
  const myCards = useTypedSelector((state) => state.cards.myCards?.cards)

  const [click, setClick] = useState(false)
  const [active, setActive] = useState('')

  const changeClick = () => {
    setClick(true)
  }

  const useBankTransfer = (e: any) => {
    e.preventDefault()
    setPaymentOption('bank')
    setClick(true)
  }

  const handleUseCard = (c: any) => {
    setPaymentOption('card', c.id)
    setClick(true)
  }

  const contest: boolean = checkVerification()

  return (
    <ExistingCardWrapper>
      <div className="title">
        <h3 className="title_text">Choose payment method</h3>
        <p className="manage_text">Manage all connected debit cards here.</p>
      </div>

      {myCards?.map((c: any) => {
        return (
          <CardContainer
            onClick={() => setActive(c.id)}
            className={active === c.id ? 'active' : ''}
            // onClick={changeClick}
          >
            <div
              className="user_card"
              onClick={() => handleUseCard(c)}
              key={c.id}
            >
              <img src={c?.card_logo} alt="" className="card_img" />
              <div className="suffix_expiry_wrapper">
                <p className="suffix_text">{`**** ${c?.card_suffix}`}</p>
                <p className="expiry_text">
                  {`${c?.expiry_month}/${c?.expiry_year.slice(2, 4)}`}
                </p>
              </div>
            </div>
            <div className="card_arrow">
              <img src={CardArrowSvg} alt="" className="" />
            </div>
          </CardContainer>
        )
      })}

      <CardContainer
        onClick={() => setActive('card')}
        className={active === 'card' ? 'active' : ''}
      >
        <div
          className="card_detail"
          onClick={() => {
            setPaymentOption('card', 'new')
          }}
        >
          <CardImage className="card_detail_img" />
          <p className="card_detail_text">Add new card</p>
        </div>
        <div className="card_arrow">
          <img src={CardArrowSvg} alt="" className="" />
        </div>
      </CardContainer>
      {contest && (
        <CardContainer
          onClick={() => setActive('bank')}
          className={active === 'bank' ? 'active' : ''}
        >
          <div className="card_detail" onClick={useBankTransfer}>
            <div className="svg_wrapper">
              <img src={BankCardSvg} alt="" />
            </div>
            <p className="card_detail_text">Use Bank Transfer</p>
          </div>
          <div className="card_arrow">
            <img src={CardArrowSvg} alt="" className="" />
          </div>
        </CardContainer>
      )}
    </ExistingCardWrapper>
  )
}

export default ExistingCard
